export function getActivityNameFromType(type, plurale) {
    if(type === "beaches") return "spiaggia"
    if(type === "hotels") return "hotel"
    if(type === "pointsOfInterest") return "punto d'interesse"
    if(type === "cities") return "città"
}